<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("binNumbers") }}</div>
      <div>
        <router-link
          v-if="
            cinema_manager_add_edit_disabled != 3 &&
            $can('create', 'Bin Numbers')
          "
          class="btn-blue"
          to="add-bin-Numbers"
          >{{ $t("add") }}</router-link
        >
      </div>
    </div>

    <div class="white-wrapper mt-5">
      <div class="row">
        <div class="col-md-4">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.bank && selected.bank.length > 0
                  ? 'shift-up'
                  : 'd-none'
              "
              >{{ $t("select") }} {{ $t("bank") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <multiselect
                :options="banks"
                :searchable="true"
                :placeholder="
                  selected.bank && selected.bank.length > 0
                    ? selected.bank
                    : $tc('selectBank')
                "
                label="bank_name"
                track-by="bank_id"
                @select="onSelectHandler('bank', $event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
              <Tooltip :title="$t('enterbankname')" />
            </div>
            <p class="error_message"></p>
          </div>
        </div>

        <div
          class="col-md-4 float-right d-flex"
          v-if="selected.bank.length > 0"
        >
          <b-form-input
            v-debounce:300="onSearch"
            v-model="searchValue"
            placeholder="Search..."
          ></b-form-input>
        </div>
      </div>

      <table class="list-view-table">
        <thead>
          <tr>
            <th>
              <img
                v-if="this.columnName != 'bin_card_type'"
                @click="onSortValue('bin_card_type', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('bin_card_type', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('bin_card_type', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("cardtype") }}
            </th>
            <th>{{ $t("binNumbers") }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="BinList.length > 0">
          <tr
            v-for="(binnumber, binnumberIndex) in BinList"
            :key="binnumberIndex"
          >
            <td>{{ binnumber.bin_card_type }}</td>
            <td>{{ binnumber.bin_ranges }}</td>
            <td v-if="binnumber.bin_isManually == 'Y'">
              <button
                v-if="$can('update', 'Bin Numbers')"
                class="btn-blue"
                @click="GotoManual(binnumber)"
              >
                Edit
              </button>
            </td>
            <td v-else></td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="3">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import MarketingService from "@/services/MarketingService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      submitted: false,
      selected: {
        bank: "",
      },
      bank_id: "",
      bankname: [],
      BinList: [],
      banks: [],

      debounce: null,
      searchValue: "",

      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",
    };
  },
  beforeMount() {
    this.cinema_manager_add_edit_disabled =
      this.secureStore.get("USINFO").role_id;
    this.getBankList();
  },
  mounted() {},
  methods: {
    onSearch: function () {
      this.viewBankBinNumbers(this.bank_id);
    },
    onSortValue(columnName, orderBy) {
      if (this.bank_id.length == 0) {
        return this.$toasted.show("Please select bank");
      }
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.viewBankBinNumbers(this.bank_id);
    },
    getBankList: function () {
      let payload = {
        tableName: "ms_banks",
        bank_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.banks = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    viewBankBinNumbers(bank_Id) {
      let payload = {
        bank_id: bank_Id,
        searchValue: this.searchValue,
        columnName: this.columnName,
        orderBy: this.orderBy,
      };
      MarketingService.viewBinNumbers(payload).then((response) => {
        console.log("response :", response);
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.BinList = data.Records;
          }
        }
      });
    },
    onSelectHandler: function (type, value) {
      if (type == "bank") {
        this.BinList = null;
        this.bank_id = value.bank_id;
        this.selected.bank = value.bank_name;
        this.viewBankBinNumbers(value.bank_id);
      }
    },
    GotoManual: function (data) {
      this.$router.push({
        path: "/marketing/edit-bin-Numbers",
        query: { bin_id: data.bin_id, bank_id: data.bank_id },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/BinNumbersComponents/binNumbers.vue